import React from 'react';

interface AlertProps {
	message: string;
	onClose: () => void;
	isVisible: boolean;
}

const Alert: React.FC<AlertProps> = ({ message, onClose, isVisible }) => {
	if (!isVisible) return null;

	return (
		<div className="fixed inset-0 flex items-center justify-center z-50 bg-gray-950 bg-opacity-80">
			<div className="bg-gray-900 py-6 px-8 rounded-lg shadow-lg w-full max-w-sm text-center relative p-10">
				<p className="text-lg font-semibold mb-6">{message}</p>
				<a
					onClick={onClose}
					className="absolute top-2 right-3 text-gray-400 hover:text-gray-200 text-2xl"
					aria-label="Close"
				>
					&times;
				</a>
				<a
					onClick={onClose}
					className="px-6 py-3 rounded-lg font-medium text-gray-900 bg-gray-300 hover:bg-gray-200 transition duration-300 shadow"
				>
					OK
				</a>
			</div>
		</div>
	);
};

export default Alert;
